import React, { useCallback, useState } from "react";
import ReactModal from "react-modal";
import { LoadingButton } from "../shared/loading-button";
import { useAuth0 } from "@auth0/auth0-react";
import ai from "../../helpers/axios";
import { toast } from "react-toastify";
import getApiErrorMessage from "../../helpers/get-api-error-message";

const PaymentUnlinkModal = ({ payment, open, onRequestClose, ...props }) => {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    setIsLoading(true);

    try {
      const token = await getAccessTokenSilently().catch((e) => {
        console.error(e);
        return loginWithRedirect();
      });

      const provider = payment?.chargeId
        ? "stripe"
        : ["clients", "operators", "amex"].includes(payment.targetingPayments) ? "xero" : "plaid";
      const baseUrl = `/api/${provider}/transactions/${payment?._id}`;
      const isIncidental = !!payment?.incidentalChargeId;
      const unlinkUrl = isIncidental
        ? `${baseUrl}/unlink-trip`
        : payment?._lineItemID
          ? `${baseUrl}/line-items/${payment._lineItemID}/unlink`
          : `${baseUrl}/unlink`;
      const body = {};
      if (payment?._lineItemID) {
        if (isIncidental) {
          body.lineItemID = payment._lineItemID;
        } else {
          if (payment?.clientPaymentHistoryId) body.clientPaymentHistoryId = payment.clientPaymentHistoryId;
          if (payment?.operatorPaymentHistoryId) body.operatorPaymentHistoryId = payment.operatorPaymentHistoryId;
        }
      }
      if (isIncidental && payment?.strict) body.strict = true;
      await ai.auth(token).post(unlinkUrl, body);
    } catch (error) {
      toast.error(getApiErrorMessage(error, "Error unlinking transaction."));
    } finally {
      await onRequestClose();

      setIsLoading(false);
    }
  }, [getAccessTokenSilently, loginWithRedirect, payment?._id, payment?.targetingPayments, payment?.chargeId, payment?.incidentalChargeId, payment._lineItemID, payment.clientPaymentHistoryId, payment.operatorPaymentHistoryId, payment?.strict, onRequestClose]);

  return (
    <ReactModal
      isOpen={open}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      style={{
        overlay: {
          zIndex: 999999,
          backgroundColor: "rgb(32 53 68 / 50%)",
        },
        content: {
          width: "auto",
          border: "none",
          maxWidth: "700px",
          maxHeight: "80vh",
          minWidth: "calc(min(500px, 95vw))",
          borderRadius: "0",
          boxShadow: "10px 10px 91px -17px rgb(0 0 0 / 25%)",
        },
      }}
      {...props}
      appElement={document.getElementById("app")}
    >
      <div className="modal-header base-modal">
        <h4>
          Unlink Payment from the Trip
        </h4>
      </div>

      <div className="modal-body base-modal modal-body-with-scroll">
        <div className="w-100 mt-20">
          You are about to unlink this payment from the trip. This action cannot be undone. Are you sure you want to
          continue?
        </div>
      </div>

      <div className="modal-footer w-100 mt-20 d-flex gap-20">

        <button
          className="base-button evo-blue flex-half"
          type="button"
          onClick={() => onRequestClose(false)}
          disabled={isLoading}
        >
          Cancel
        </button>

        <LoadingButton
          className="base-button btn-danger flex-half"
          type="button"
          onClick={handleSubmit}
          isLoading={isLoading}
        >
          Submit
        </LoadingButton>
      </div>
    </ReactModal>
  );
};

export default PaymentUnlinkModal;
